import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import useReactRouter from 'use-react-router';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import Header from './Header';
import AppSelector from './AppSelector';
import ComponentSelector from './ComponentSelector';
import Configuration from './Configuration';
import ManageConfig from './ManageConfig';
import AddConfiguration from './AddConfiguration';
import * as actions from '../../Store/Actions';
import { authProvider } from '../../authProvider';


const useStyles = makeStyles(theme => ({
    content: {
        padding: theme.spacing(1),
    },
    toolbar: theme.mixins.toolbar,
    div1: {
        float: 'left',
        overflowY: 'auto',
        width: 210,
        boxShadow: '2px 2px 2px 2px #aaaaaa',
        margin: theme.spacing(1),
        height: 575,
        radius: '10px'
    },
    div2: {
        float: 'left',
        overflowY: 'auto',
        width: 220,
        boxShadow: '2px 2px 2px 2px #aaaaaa',
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        height: 575,
        radius: '10px',
    },
    div3: {
        overflowY: 'auto',
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        height: 575,
        boxShadow: '2px 2px 2px 2px #aaaaaa',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    cardheader: {
        fontSize: 10,
        background: 'linear-gradient(45deg,#bdbdbd 90%,#bdbdbd 10%)',
        color: 'black',
        radius: '15px'
    },
    pos: {
        marginBottom: 12,
    },
    editdiv: {
        float: 'left',
        overflowY: 'auto',
        boxShadow: '2px 2px 2px 2px #aaaaaa',
        height: 575,
    },
    scedit: {
        margin: theme.spacing(1),
    }
}));

export default function ClientLayout() {
    const classes = useStyles();
    let sessionAlert = null;
    const reduxAuth = useSelector((state) => state.auth)
    const dispatch = useDispatch();
    const { location, history } = useReactRouter();
    if (reduxAuth.isSessionValid.toString() === "false") {
        sessionAlert =
            <Alert severity="warning" className={classes.alert} action={
                <Button color="inherit" size="small" onClick={() => authLogoutClick()}>
                    LOGOUT
                </Button>}>
                <AlertTitle>Error</AlertTitle>
                For security reasons, Your session has expired. Please save your work and re-login to continue.
            </Alert>;
    }
    const authLogoutClick = () => {
        dispatch(actions.authLogout());
        authProvider.logout();
    }
    // console.log("location.state",location.state)

    return (
        // Same Component Edit
        <div className={classes.root}>
            <div>
                <Header></Header>
            </div>
            {reduxAuth.fullscreentoggle===false? <><div className={classes.div1}>
                <AppSelector></AppSelector>
            </div>
            <div className={classes.div2}>
                <ComponentSelector></ComponentSelector>
            </div></>:null}
           
            <main>
                {sessionAlert}
                <div className={classes.div3} >
                    <Switch>
                        <Route exact path='/Config'>
                            <Configuration></Configuration>
                        </Route>
                        <Route exact path='/ManageConfig'>
                            <ManageConfig></ManageConfig>
                        </Route>
                        <Route exact path='/AddConfiguration'>
                            <AddConfiguration></AddConfiguration>
                        </Route>
                        <Redirect from="/" to="/Config" />
                    </Switch>
                </div>
            </main>
        </div>
        //End
    );
}